import React from 'react';
import { getAntd,getEcCom } from '../../util/convert';
import * as _ from "../../util/public/common";
import src from "../../util/public/source";
import * as DetailUtil from "../../util/public/detailUtil";

export default class WeaSapBrowser extends React.Component{
    constructor(){
        super();
    }
    doBrowserChange = (_ids, _names, _datas) => {
        const { WeaTools } = getEcCom();
        const { weaBrowserProps,onChange } = this.props;
        const { fieldid,rowIndex,dataParams } = weaBrowserProps||{};
        const { fielddbtype,requestid } = dataParams;
        let params = {fromNodeorReport:"0", fieldid,rowIndex,requestid,fielddbtype};
        params["datas"] = JSON.stringify(_datas);
        WeaTools.callApi('/api/SapIntegration/browser/getSapBrowserWfFieldId', 'POST', params).then(result =>{
            let wfDatas = {};
            if (result.fieldIds) {
                result.fieldIds.forEach(function(item,index){
                    let items = item.split("_");
                    let fieldid = items[0];
                    wfDatas["field" + fieldid] = wfform.getFieldValue("field" + fieldid);
                });
            }
            params["wfid"]=wfform.getBaseInfo().workflowid;
            params["wfDatas"] = JSON.stringify(wfDatas);
            WeaTools.callApi('/api/SapIntegration/browser/assignToBill', 'POST', params).then(result =>{
                this.triggerLink(result);
                onChange && onChange(result.datas);
            });
        });        //此接口由SAP模块提供，将浏览按钮选中数据转换为流程识别的数据

    }
    render(){
        const { WeaBrowser,WeaTools } = getEcCom();
        const { weaBrowserProps } = this.props;
        const {displaySearchAdInBar, scrollx,browTitle} = weaBrowserProps.dataParams;
        return (
            <WeaBrowser ecId={`${this && this.props && this.props.ecId || ''}_WeaBrowser@dv69jt`}  {...weaBrowserProps} onChange={this.doBrowserChange} sap={true}   title={browTitle} displaySearchAdInBar={displaySearchAdInBar} scrollx={true}/>
        )
    }

    triggerLink=(v)=>{
        const changeDatas = {};
        const addRowInfo = [];
        const linkageSql = [];
        if (_.isEmpty(v))
            return true;
        let changeValue = v["changeValue"];
        //字段联动,主表联动明细
        const addRows = v["addDetailRow"];
        !_.isEmpty(addRows) && _.forIn(addRows, (rowDatas, detailMark) => {
            rowDatas && rowDatas.map(rowData => {
                addRowInfo.push({ detailMark, rowData });
            });
        });
        addRowInfo.map((item,index) => {
            const detailIndex = DetailUtil.addRow(item.detailMark, item.rowData, true, false);
        });
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/public/wea-sap-browser/single.js